// Copy of the "Packets" walkthrough. The rules every text follows are in ../../de/help.js.
// Field and button names are written as the packet pages show them (../packet.js).
export default {
  title: "Packets",
  // Short names of the views, for the header, the timeline and "Continue to …".
  section: {
    PacketDetail: "Packet",
    MaterialOverview: "Material catalogue",
    ProjectDetail: "Project",
    CustomerDetail: "Customer",
  },
  // The pages outside packet management where a packet has an effect. Set apart on the timeline and
  // named with this in front.
  related: "Connections",
  step: {
    "detail-head": {
      text: "The head names the packet. The icon on the left says which catalogue it bundles from.",
    },
    "detail-name": {
      text: "The name is all a packet says about itself. It is what you look for in a project and on a customer.",
    },
    "detail-items": {
      text: 'Below it is what the packet holds. "Add material" takes one more in from the catalogue; it shows up as a new row of the table straight away.',
    },
    "detail-row": {
      text: "Every row is one entry of the packet. A click on the row opens the record in its catalogue, the bin on the right takes it out again. The billing unit and the purchase price stand beside it, the record's note under its name.",
    },
    "detail-save": {
      text: "Save writes the name and the entries. Projects that already took the packet are left as they are.",
    },
    again: {
      text: "This button is on every page that has an explanation. One click starts it again.",
    },
    // Where packets act: the catalogue that lists them, the register a packet fills, and the window
    // that offers one.
    row: {
      text: "Packets are rows of their catalogue's table, above the materials. The row names the packet and the number of its entries.",
    },
    filter: {
      text: "The filter above the table shows just the packets, just the materials, or both.",
    },
    create: {
      text: "The same button also makes packets: create new packet makes a material packet here. That kind cannot be changed later on.",
    },
    catalogue: {
      text: "The materials themselves stand beside them, with unit and purchase price. A packet only notes which belong together.",
    },
    "project-register": {
      text: "In a project every material stands on its own in this register. Add brings a whole packet in at once.",
    },
    "project-packet": {
      text: "The search finds packets ahead of single materials. A click on the packet takes in every material the project does not have yet.",
    },
    "customer-assign": {
      text: "On a customer the packets stand above the catalogue too. A packet writes a price row for each of its entries.",
    },
  },
}
